export enum FeatureFlagsLocalStorageEnum {
    EnableV2Overview = "v2OverviewEnabled",
    EnableSidebarV2Enabled = "sidebarV2Enabled",
    EnableV2Migration = "v2migration",
    EnableUrlParamSync = "urlParamSync",
    EnableTeleop3PreviewButton = "teleop3PreviewButton",
}
